/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'negativeCurrencyToParenthesis' })
export class NegativeCurrencyToParenthesisPipe implements PipeTransform {
  transform(value: any): any {
    return !!value && value.charAt(0) === '-' ? '(' + value.substring(1, value.length) + ')' : value;
  }
}
